<template>
  <div class="my-card">
    <div class="my-information">
      <img class="my-information-img" src="@/assets/images/bg.png" background-size="cover" />
      <div class="information-box">
        <img class="information-c-img" src="@/assets/images/icon_boy.png" background-size="cover"/>
        <div class="information-name">
          <div class="information-state">
            <p>{{deviceName}}</p>
            <div :class="[status==='在线'?'online device-state':'offline device-state']">{{status}}</div>
          </div>
          <div class="information-imei">
            <p>IMEI:</p>
            <span>{{imei}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="option-box" v-for="(item,index) in myOptionList" :key="index">
      <template v-for="(val,ind) in item">
        <div v-if="val.show" @click="pageTurn(val)" :key="ind">
          <div v-if="!val.switch" class="card-option">
            <div class="card-left">
              <img class="option-img" :src="val.imgaddr" background-size="cover" />
              <p class="option-title">{{val.title}}</p>
            </div>
            <div class="option-right">
              <div class="arrows"></div>
            </div>
          </div>
          <div v-else class="more-flex">
            <div class="more-option">
              <img class="more-img" src="@/assets/images/limit_shutdown.png" background-size="cover"/>
              <p class="more-surplus">限制按键关机</p>
              <van-switch class="switch-flex" v-model="checked" @change="onChange"  size="22px" />
            </div>
          </div>
        </div>
      </template>
    </div>
    <van-popup v-model="showPop" round @close="close">
      <div class="fill-number">
        <img class="fill-img" src="@/assets/images/unbind.png" background-size="cover" />
        <p>解除绑定</p>
        <span>
          解绑后，该设备设置的信息将会被清空
        </span>
        <div class="fill-btn">
          <van-button @click="close" class="fill-cancel" type="primary">取消</van-button>
          <van-button class="fill-confirm" type="primary" @click="save">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
    data() {
        return {
        imei:'',//设备imei
        status:'',//在线状态
        deviceName:'',//设备名称
        showPop:false,//解绑提示
        myOptionList:[],
        checked:false,
        }
    },
    watch: {
        checked(now, old) {//限制开关机，开关变化请求接口
            // this.sendData.param = now ? "ON" : "OFF"
            if (now == this.sendData.param) {//避免无效请求
                return
            } else {
                this.sendData.param = now ? "ON" : "OFF"
                this.$http.post(this.$api.sosSetings.POST_SENDINSTRUCTION, this.sendData).then(res => {
                    if (res.code === 0) {
                        this.$toast({
                            message: '修改成功',
                            duration: 2000,
                            icon: require('@/assets/images/safety-fence/correct.png'),
                        });
                    } else {
                        this.checked = !this.checked;
                        this.sendData.param = !this.sendData.param
                        this.$toast({
                            message: res.msg,
                            duration: 2000,
                            icon: require('@/assets/images/safety-fence/wrong.png'),
                        });
                    }
                });
            }

        }
    },
    created() {
        this.getUserinfo()
        this.getLimitShutdown()
    },
    methods: {
      getLimitShutdown(){
      let data = {
        ver:1,
        method:'getLimitShutdownSwitchStatus',
        instructionId: this.$intfilter.instructFilter('限制关机') || ''
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.checked= res.data==='1'?true:false;
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    onChange(e) {
      console.log(e,555)
      let data = {
        ver:1,
        method:'setLimitShutdownSwitch',
        switchStatus: e ?'1':'0',
        instructionId: this.$intfilter.instructFilter('限制关机') || ''
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.checked= e;
            this.$toast({
              message: "状态修改成功",
              icon: "success",
              duration: 1000
            });
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
        /**
     * 获取用户信息
     */
    getUserinfo(){
      let param = {
        ver:1,
        method:'getDeviceAllInfo',
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,param).then(res => {
          if (res.code === 0) {
            let myOptionList = [
              [
              {
                  title:'通讯录',
                  imgaddr:require('@/assets/images/my_address.png'),
                  show:true,
                  url:'mailList'
              },
              {
                  title:'亲情号',
                  imgaddr:require('@/assets/images/my_family.png'),
                  show:true,
                  url:'familyNumber'
              },
              {
                  title:'SOS号码',
                  imgaddr:require('@/assets/images/my_sos.png'),
                  show:true,
                  url:'sosSet'
              }
              ],
              [
              {
                  title:'安全围栏',
                  imgaddr:require('@/assets/images/my_guard.png'),
                  show:true,
                  url:'safetyFence'
              },
              {
                  title:'上课免打扰',
                  imgaddr:require('@/assets/images/my_disturb.png'),
                  show:true,
                  url:'noDisturbing'
              },
              {
                  title:'发送短消息',
                  imgaddr:require('@/assets/images/send_voice.png'),
                  show:true,
                  url:'voiceList'
              },
              {
                  title:'情景模式',
                  imgaddr:require('@/assets/images/contextual.png'),
                  show:true,
                  url:'contextual'
              },
              {
                  title:'闹钟设置',
                  imgaddr:require('@/assets/images/alarm_clock.png'),
                  show:true,
                  url:'alarmClock'
              }
              ],
              [
              {
                  title:'设备远程关机',
                  imgaddr:require('@/assets/images/more_switch.png'),
                  show:true,
                  url:'shutdown',
                  toData:'shutdown'
              },
              {
                  title:'设备远程重启',
                  imgaddr:require('@/assets/images/more_reser.png'),
                  show:true,
                  url:'shutdown',
                  toData:'restart'
              },
              {
                  title:'限制按键关机',
                  imgaddr:require('@/assets/images/limit_shutdown.png'),
                  show:true,
                  switch:true
              }
              ],
              [
              {
                  title:'设备更换',
                  imgaddr:require('@/assets/images/replacement.png'),
                  show:true,
                  url:'updateDevice'
              },
              {
                  title:'设备解绑',
                  imgaddr:require('@/assets/images/my_unbundle.png'),
                  show:true,
                  unbind:true
              }
              ]
            ];
            this.$store.commit('set_devTypeList', JSON.stringify(res.data.instructionList));
            this.imei = res.data.locationInfo.imei
            this.status =  res.data.locationInfo.status==="online"?'在线':'离线'
            this.deviceName = res.data.deviceName
            myOptionList[0][0].show = res.data.instructionList.some(item=>item.name==='白名单')
            myOptionList[0][1].show = res.data.instructionList.some(item=>item.name==='亲情号码')
            myOptionList[0][2].show = res.data.instructionList.some(item=>item.name==='SOS号码')
            myOptionList[1][1].show = res.data.instructionList.some(item=>item.name==='上课免打扰')
            myOptionList[1][2].show = res.data.instructionList.some(item=>item.name==='短消息')
            myOptionList[1][3].show = res.data.instructionList.some(item=>item.name==='情景模式')
            myOptionList[1][4].show = res.data.instructionList.some(item=>item.name==='闹钟设置')
            myOptionList[2][0].show = res.data.instructionList.some(item=>item.name==='远程关机')
            myOptionList[2][1].show = res.data.instructionList.some(item=>item.name==='远程重启')
            myOptionList[2][2].show = res.data.instructionList.some(item=>item.name==='限制关机')
            myOptionList[3][0].show = res.data.instructionList.some(item=>item.name==='设备更换')
            myOptionList[3][1].show = res.data.instructionList.some(item=>item.name==='设备解绑')
            this.myOptionList = myOptionList
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    /**
     * 页面跳转
     */
    pageTurn(item){
      if(item.unbind){
        this.showPop = true;
        return
      }
      if(item.title === "设备更换"){
        this.$router.push({ name: item.url , query: { data: this.imei } });
        return
      }
      this.$router.push({ name: item.url , query: { data: item.toData?item.toData:'' } });
    },
    close(){
      this.showPop = false
    },
    //确认解绑
    save(){
      let data = {
          ver:1,
          method:'unboundDevice',
          imei:this.imei
        }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
              this.$toast('解绑成功')
              this.showPop = false;
              this.$router.push({ name: 'deviceOption'});
          } else {
           this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    }
  }
};
</script>

<style scoped>
.my-card{
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: #f8f8f8;
  padding: 50px 0 100px;
}
.my-information{
  position: relative;
  width: 670px;
  height: 240px;
  border-radius: 20px;
}
.my-information .my-information-img{
  width: 670px;
  height: 240px;
  position: absolute;
  left: 0;
  top: 0;
}
.information-box{
  position: absolute;
  margin-left: 42px;
  height: 100%;
  display: flex;
  align-items: center;
}
.information-c-img{
  width: 96px;
  height: 96px;
}
.information-name{
  margin-left: 20px;
  color: #fff;
}
.information-state{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.information-state>p{
  font-size: 34px;
  font-weight: 500;
}
.information-state .device-state{
  margin-left: 18px;
  font-size: 24px;
  font-weight: 500;
  letter-spacing:4px;
  width: 80px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-top-left-radius:20px;
  border-top-right-radius:20px;
  border-bottom-right-radius:20px;
}
.information-state .online{
  color: #FFFFFF;
  background-color: #4ED964;
}
.information-state .offline{
  background: #C2C2C2;
  color: #FFFFFF;
}
.information-imei{
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 400;
}
.information-imei>span{
  margin-left: 18px;
}
.option-box{
  margin-top: 30px;
  width: 670px;
  background: #fff;
  border-radius: 20px;
}
.more-option{
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.more-option .more-img{
  width: 64px;
  height: 64px;
  margin: 0 33px 0 32px;
}
.more-option .more-surplus{
  font-size: 30px;
  font-weight: 400;
  flex: 1;
}
.more-option .switch-flex{
  margin-right: 36px;
}
.card-option{
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-option .option-img{
  width: 64px;
  height: 64px;
  margin-right: 33px;
}
.card-option .option-title{
  font-size: 30px;
  font-weight: 400;
  color: #111111;
}
.option-right{
  display: flex;
  align-items: center;
}
.right-img{
  width: 44px;
  height: 20px;
  margin-right: 15px;
}
.card-left{
  display: flex;
  align-items: center;
  margin-left: 32px;
}
.arrows{
  width: 15px;
  height: 15px;
  transform:rotate(45deg);
  border-top: 3px solid #ccc;
  border-right: 3px solid #ccc;
  margin-right: 36px;
}
.fill-number{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 32px 32px;
}
.fill-number>p{
  margin: 40px 0 3px;
  font-size: 36px;
  font-weight: 600;
  color: #111111;
}
.fill-number>span{
  text-align: center;
  margin: 30px 0 10px;
  font-size: 26px;
  font-weight: 400;
  color: #666666;
}
.my-card .fill-number .fill-img{
  width: 356px;
  height: 192px;
}
.my-card .fill-number .fill-btn{
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.btn-box{
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 20px;
}
</style>
<style  lang="scss">
.my-card .btn-box .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background-color: #fff;
  font-weight: 600;
  color: #FC4D56;
}
.my-card .fill-number .van-button{
  width: 200px;
  height: 68px;
}
.my-card .fill-number .fill-cancel{
  margin-right: 36px;
  background: #FFFFFF;
  border-radius: 34px;
  color: #01ADA9;
  border: 2px solid #01ADA9;  
}
.my-card .fill-number .fill-confirm{
  background: #01ADA9;
  border-radius: 34px;
  border: 2px solid #01ADA9;
  color: #fff;
}
.my-card .switch-flex{
  display: flex;
  align-items: center;
}
.my-card .van-switch--on{
  background-color: #02ADA9 !important;
}
</style>
